import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';


import TeamTrainingMatterLine from './TeamTrainingMatterLine';


class TeamTrainingMattersTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      csv_team_training_matter_id: null,
      modal: false,
      dados: [],
    };

    this.importCSV = this.importCSV.bind(this);
    this.openCsvModal = this.openCsvModal.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.materias !== 'undefined') {
      this.setState({dados: newProps.materias});
    }
  }

  openCsvModal (csv_team_training_matter_id) {
    this.setState({modal: true, csv_team_training_matter_id: csv_team_training_matter_id})
  }


  importCSV(event) {
    event.preventDefault();
    var self = this;
    var data = new FormData();
    var csv_file = document.querySelector(`input[name="filecsv"]`).files[0];
    data.append("file", csv_file);
    data.append("id",  self.state.csv_team_training_matter_id);
    var header = this.refs.request_api.header();
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/importar/csv', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
        console.error(error);
      });
    });   
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Matérias do treinamento</h3>
  <hr/>
  <table className="table table-hover table-stripped table-bordered">
    <thead>
      <tr>
        <th className="text-center" style={{width: '26%'}}>Matéria</th>
        <th className="text-center" style={{width: '5%'}}>Programação</th>
        <th className="text-center" style={{width: '8%'}}>Presença</th>
        <th className="text-center" style={{width: '9%'}}>Data de início</th>
        <th className="text-center" style={{width: '9%'}}>Data de fim</th>
        <th className="text-center" style={{width: '13%'}}>Realização da prova</th>
        <th className="text-center" style={{width: '6%'}}>Dificuldade</th>
        <th className="text-center" style={{width: '10%'}}>ID Moodle</th>
        <th className="text-center" style={{width: '10%'}}>Grupo Moodle</th>
        <th className="text-center" style={{width: '14%'}}>Ações</th>
      </tr>
    </thead>
    {self.state.dados ?
      <tbody>
        {Object.keys(self.state.dados).map(function(k) {
          var materia = self.state.dados[k];
          return (
            <TeamTrainingMatterLine key={materia.id || k} refreshData={self.props.refreshData} handleAlert={self.props.handleAlert} team_data={self.props.team_data} team_id={self.props.team_id} lista_instrutores={self.props.lista_instrutores} dificuldades={self.props.dificuldades} materia={materia} matter_moodle_ids={self.props.matter_moodle_ids} openCsvModal={self.openCsvModal} errorsMoodle={self.props.errorsMoodle} />
          );
        })}
      </tbody>
    : ""
    }
  </table>

  {/* Importação de Resultados */}
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">Importar resultados</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, csv_team_training_matter_id: null})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.importCSV}>
        <div className="form-group">
          <label>Arquivo CSV:</label>
          <input type="file" name="filecsv" className={"form-control"} placeholder="Arquivo" value={this.state.file} onChange={this.handleChange.bind(this, 'file')} />
        </div>     
        <div className="form-group">
          <button className="btn btn-success btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Importar</button>
        </div>
      </form>
      <hr />
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, csv_team_training_matter_id: null})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>


</div>
    );
  }
}

export default TeamTrainingMattersTab;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamTrainingMattersTab.js